import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Cashier from "../../Assets/URUZ.png";
import LoadingFull from "../../components/LoadingFull";
import Navbar from "../../components/Navbar";
import { onSave } from "../../config/config";
import FETCH_API from "../../config/fetch_api";
import { baseUrl, imageBaseUrl, router } from "../../Constants";
import api from "../../request";
import { decrypt, encrypt } from "../../utils/enkripsi";
import { formatDate, formatMinutes } from "../../utils/formatDate";
import { showLog } from "../../utils/log";
import { onHitung } from "../../utils/onHitung";
import { socket } from "../../utils/socket";

export default function MetodePembayaran({ location }) {
  const state = useSelector((state) => state?.dataPrepare?.order);
  const xendit = useSelector((state) => state?.dataXendit);
  const order = state?.data?.[0]?.data;
  const { addToast } = useToasts();
  let navigate = useNavigate();

  const branch = JSON.parse(localStorage.getItem("dataBranch"));
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  const isPillowcake = String(userServer || "")
    .trim()
    .toLowerCase() === "pillowcake";
  const [loading, setLoading] = React.useState(false);
  const [detailUsers, setDetailUsers] = React.useState({
    nama: "",
    email: "",
  });
  const [detailTrans3, setDetailTrans3] = React.useState([]);
  const [pay, setPay] = React.useState([]);

  async function hitUruzProAPI(url, payload, token) {
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        "Accept-Encoding": "gzip;q=1.0, compress;q=0.5",
      };
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      const status = response.status;
      const ok = response.ok;
      let raw = "";
      let data = null;
      try {
        raw = await response.text();
        data = raw ? JSON.parse(raw) : null;
      } catch (_) {
        data = null;
      }

      showLog(`UruzPro Response Status: ${status} OK: ${ok}`);

      if (!ok) {
        const apiMsg =
          (data &&
            (data.message ||
              data.responseMessage ||
              data.responseDescription ||
              data.error ||
              (Array.isArray(data.errors) && data.errors[0]?.message))) ||
          (raw && raw.trim()) ||
          `HTTP ${status}`;
        throw new Error(apiMsg);
      }

      showLog(`UruzPro Response Data: ${raw || "<empty>"}`);
      return data ?? {};
    } catch (error) {
      showLog(`Error in hitUruzProAPI: ${error?.message || error}`);
      throw error;
    }
  }

  async function getQRNobu(items, detailDataPayload, detailTransPayload) {
    showLog("MetodePembayaran Masuk getQRNobu");
    const tokenLogin = localStorage.getItem("tokenUruzPro") || "";
    const serialNumber = localStorage.getItem("serialNumber") || "";
    const login = (() => {
      try {
        return JSON.parse(localStorage.getItem("login"));
      } catch (_) {
        return null;
      }
    })();

    if (!detailDataPayload?.grand_total_nett || detailDataPayload.grand_total_nett <= 0) {
      addToast("Harap tambahkan produk terlebih dahulu", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    if (!serialNumber) {
      addToast("Serial number belum ada. Harap set serial number terlebih dahulu.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    if (!tokenLogin) {
      addToast("Token UruzPro belum ada. Harap login/refresh token terlebih dahulu.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    const resolvedUserId = login?.id || login?.nama || "";
    const resolvedUserServer = userServer;
    const resolvedTransactionUrl =
      localStorage.getItem("urlTransaction") ||
      "https://hot.uruz.id/api/trans-s-si-v10/paymentCallbackSI/Mobile";

    const resolvedPaymentOthersCoa =
      items?.coa ||
      items?.payment_others_coa ||
      detailDataPayload?.payment_others_coa ||
      "";

    if (!resolvedPaymentOthersCoa) {
      addToast("COA Nobu belum tersedia. Harap cek setting EDC/COA.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    const resolvedPaymentOthersCoaName =
      items?.coa_name ||
      items?.payment_others_coa_name ||
      detailDataPayload?.payment_others_coa_name ||
      items?.name ||
      items?.id ||
      "";


    const invoiceOwnerId =
      detailDataPayload?.id ||
      detailDataPayload?.trans_id ||
      branch?.detailData ||
      "UNKNOWN";
    const invoiceTimestamp = Date.now();
    const invoiceUrl = `https://uruz-pdf.s3.ap-southeast-1.amazonaws.com/${encodeURIComponent(
      String(invoiceOwnerId)
    )}/uruz-pdf-${invoiceTimestamp}.pdf`;

    const payloadTransaction = {
      from_origin: "*",
      userServer: resolvedUserServer,
      userId: resolvedUserId,
      trans_from: detailDataPayload?.trans_from || "pos",
      transMode: detailDataPayload?.transMode || "new",
      detailData: {
        ...detailDataPayload,
        payment_type: 3,
        payment_others_edc: items?.id || "Nobu",
        payment_others_coa: resolvedPaymentOthersCoa,
        payment_others_coa_name: resolvedPaymentOthersCoaName,
        payment_others_value: detailDataPayload.grand_total_nett,
        total_bayar: detailDataPayload.grand_total_nett,
        kembali: 0,
      },
      detailTrans:
        (Array.isArray(state?.dataOrder) &&
          state.dataOrder.map((x) => ({
            category_id: x.category_id || "",
            gambar_produk: x.gambar_produk || x.picpath1_thumb || "-",
            product_name: x.product_name || x.name || "",
            kitchen_type_id: x.kitchen_type_id || "",
            name: x.name || x.product_name || "",
            price: x.price || 0,
            product_id: x.product_id || "",
            qty_order: x.qty_order || x.qty || x.item || 0,
            qty: x.qty || x.item || 0,
            status_save: x.status_save || "0",
          }))) ||
        (Array.isArray(detailTransPayload)
          ? detailTransPayload
          : []),
      discountsNote: JSON.stringify([]),
      chargesNote: JSON.stringify([]),
    };

    // const invoiceUrl =
    //   detailDataPayload?.invoiceUrl ||
    //   detailDataPayload?.invoice_url ||
    //   localStorage.getItem("invoiceUrl") ||
    //   `${baseUrl}#/metode-pembayaran-nobu/${branch?.detailData}`;
    const partnerRefBase =
      payloadTransaction.detailData?.id?.split("-")?.[0] ||
      payloadTransaction.detailData?.id ||
      branch?.detailData ||
      "REF";
    const partnerReferenceNo = `${partnerRefBase}-${Date.now()}`;

    const additionalInfo = {
      userServer: userServer,
      transId: payloadTransaction.detailData?.id,
      // payloadTransaction,
      // urlTransaction: resolvedTransactionUrl,
      // token: tokenLogin,
    };

    const apiPayload = {
      amount: Math.ceil(payloadTransaction.detailData.grand_total_nett),
      partnerReferenceNo,
      serialNumber,
      payment_type: "qris_client",
      invoiceUrl,
      additionalInfo,
    };

    console.log("payload Nobu", apiPayload);
    // return;

    const result = await hitUruzProAPI(
      "https://uruzpro.com/transactions-services/transactions/aisinoQROpenAPI/openAPIV3",
      apiPayload,
      tokenLogin
    );

    if (result?.responseStatus === "Success") {
      setLoading(false);

      localStorage.setItem("transactionNobu", result?.data?.transactionNo || "");
      navigate(router + "/bill-cashless");


      console.log("result Nobu", result);
    } else {
      setLoading(false);

      addToast(result?.message || "Gagal generate QR Nobu", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  }


  async function activateNFC(items, detailDataPayload, detailTransPayload) {
    showLog("MetodePembayaran Masuk activateNFC");
    const tokenLogin = localStorage.getItem("tokenUruzPro") || "";
    const serialNumber = localStorage.getItem("serialNumber") || "";
    const login = (() => {
      try {
        return JSON.parse(localStorage.getItem("login"));
      } catch (_) {
        return null;
      }
    })();

    if (!detailDataPayload?.grand_total_nett || detailDataPayload.grand_total_nett <= 0) {
      addToast("Harap tambahkan produk terlebih dahulu", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    if (!serialNumber) {
      addToast("Serial number belum ada. Harap set serial number terlebih dahulu.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    if (!tokenLogin) {
      addToast("Token UruzPro belum ada. Harap login/refresh token terlebih dahulu.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    const resolvedUserId = login?.id || login?.nama || "";
    const resolvedUserServer = userServer;
    const resolvedTransactionUrl =
      localStorage.getItem("urlTransaction") ||
      "https://hot.uruz.id/api/trans-s-si-v10/paymentCallbackSI/Mobile";

    const resolvedPaymentOthersCoa =
      items?.coa ||
      items?.payment_others_coa ||
      detailDataPayload?.payment_others_coa ||
      "";

    if (!resolvedPaymentOthersCoa) {
      addToast("COA Nobu belum tersedia. Harap cek setting EDC/COA.", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    const resolvedPaymentOthersCoaName =
      items?.coa_name ||
      items?.payment_others_coa_name ||
      detailDataPayload?.payment_others_coa_name ||
      items?.name ||
      items?.id ||
      "";

    const payloadTransaction = {
      from_origin: "*",
      userServer: resolvedUserServer,
      userId: resolvedUserId,
      trans_from: detailDataPayload?.trans_from || "pos",
      transMode: detailDataPayload?.transMode || "new",
      detailData: {
        ...detailDataPayload,
        payment_type: 3,
        payment_others_edc: items?.id || "Nobu",
        payment_others_coa: resolvedPaymentOthersCoa,
        payment_others_coa_name: resolvedPaymentOthersCoaName,
        payment_others_value: detailDataPayload.grand_total_nett,
        total_bayar: detailDataPayload.grand_total_nett,
        kembali: 0,
      },
      detailTrans:
        (Array.isArray(state?.dataOrder) &&
          state.dataOrder.map((x) => ({
            category_id: x.category_id || "",
            gambar_produk: x.gambar_produk || x.picpath1_thumb || "-",
            product_name: x.product_name || x.name || "",
            kitchen_type_id: x.kitchen_type_id || "",
            name: x.name || x.product_name || "",
            price: x.price || 0,
            product_id: x.product_id || "",
            qty_order: x.qty_order || x.qty || x.item || 0,
            qty: x.qty || x.item || 0,
            status_save: x.status_save || "0",
          }))) ||
        (Array.isArray(detailTransPayload)
          ? detailTransPayload
          : []),
      discountsNote: JSON.stringify([]),
      chargesNote: JSON.stringify([]),
    };

    // const invoiceUrl =
    //   detailDataPayload?.invoiceUrl ||
    //   detailDataPayload?.invoice_url ||
    //   localStorage.getItem("invoiceUrl") ||
    //   `${baseUrl}#/metode-pembayaran-nobu/${branch?.detailData}`;

    const invoiceOwnerId =
      detailDataPayload?.id ||
      detailDataPayload?.trans_id ||
      branch?.detailData ||
      "UNKNOWN";
    const invoiceTimestamp = Date.now();
    const invoiceUrl = `https://uruz-pdf.s3.ap-southeast-1.amazonaws.com/${encodeURIComponent(
      String(invoiceOwnerId)
    )}/uruz-pdf-${invoiceTimestamp}.pdf`;

    const partnerRefBase =
      payloadTransaction.detailData?.id?.split("-")?.[0] ||
      payloadTransaction.detailData?.id ||
      branch?.detailData ||
      "REF";
    const partnerReferenceNo = `${partnerRefBase}-${Date.now()}`;

    const additionalInfo = {
      userServer: userServer,
      transId: payloadTransaction.detailData?.id,
      // payloadTransaction,
      // urlTransaction: resolvedTransactionUrl,
      // token: tokenLogin,
    };

    const apiPayload = {
      amount: Math.ceil(payloadTransaction.detailData.grand_total_nett),
      partnerReferenceNo,
      serialNumber,
      payment_type: "qris_client",
      invoiceUrl,
      additionalInfo,
    };

    console.log("payload activateNFC", apiPayload);
    // return;

    const result = await hitUruzProAPI(
      "https://uruzpro.com/transactions-services/nobu-cpm/aisino-qris-nfc",
      apiPayload,
      tokenLogin
    );

    if (result?.responseStatus === "Success") {
      setLoading(false);
      navigate(router + "/bill-cashless");


      console.log("result activateNFC", result);
    } else {
      setLoading(false);

      addToast(result?.message || "Gagal generate QR Nobu", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  }

  async function edc() {
    showLog("MetodePembayaran Masuk edc");
    try {
      const res = await FETCH_API("edc-v2/getAll", {
        userId: "Admin",
        userServer: userServer,
        branch_id: branch.branchID,
      });
      setPay(res.data);
    } catch (error) { }
  }

  React.useEffect(() => {
    showLog("MetodePembayaran Masuk useEffect 1");
    edc();
    window.addEventListener("popstate", (event) => {
      navigate(router + "/lacak-pesanan");
    });
  }, [xendit]);

  React.useEffect(() => {
    showLog("MetodePembayaran Register socket payment-success");
    loginUruzPro();

    const handlePaymentSuccess = (payload) => {
      try {
        const typePayment = localStorage.getItem("typePayment") || "";
        if (typePayment !== "Nobu" && typePayment !== "NFC") return;

        const currentBranch = (() => {
          try {
            return JSON.parse(localStorage.getItem("dataBranch"));
          } catch (_) {
            return null;
          }
        })();

        const currentTransId = currentBranch?.detailData;
        const incomingTransId =
          payload?.trans_id ??
          payload?.transId ??
          payload?.transID ??
          payload?.id ??
          payload?.data?.trans_id;

        if (incomingTransId && currentTransId) {
          if (String(incomingTransId) !== String(currentTransId)) return;
        }

        setLoading(false);
        navigate(`${router}/payment-succes`);
      } catch (e) {
        setLoading(false);
        navigate(`${router}/payment-succes`);
      }
    };

    socket.on("payment-success", handlePaymentSuccess);
    return () => {
      socket.off("payment-success", handlePaymentSuccess);
    };
  }, [navigate]);

  function detailTrens(items, orderDate, branch, detailData, date) {
    showLog("MetodePembayaran Masuk detailTrens");
    return {
      product_id: items["product_id"],
      warehouse_id: detailData["default_warehouse_id"],
      coa_inv: branch.coa_inv,
      coa_sales: branch.coa_sales_inv,
      name: items["name"],
      qty: items["qty"],
      unit_id: items["unit_id"],
      price: items["price"],
      detail_note: items["detail_note"],
      total: items["total"] ? items["total"] : items["price"] * items["qty"],
      picpath1_thumb: items["picpath1_thumb"],
      ordered_by: orderDate["nama"] == "" ? "Admin" : orderDate["nama"],
      ordered_at: date.date + " " + date.time,
      promo_qty: items["qty"],
      detail_disc1: 0,
      detail_disc2: 0,
      detail_disc_value: 0,
      indent: 0,
      promo_paket: 0,
      qty_unit: 1,
      rate: 1,
      dtp_bkp: 1,
      unit_id_small: "PCS",
      curr: "IDR",
      accepted_rejected_note: "Chrome",
      accepted_rejected_by: "",
      prepared_by: "",
      prepared_at: "",
      kitchen_type_id: items.kitchen_type_id,
      promo_name: "",
      promo_price: "",
      accepted_rejected_at: null,
    };
  }

  async function onPembayaran(item) {
    showLog("MetodePembayaran Masuk onPembayaran");
    try {
      if (isPillowcake && (item?.id === "Nobu" || item?.id === "NFC")) {
        addToast("Metode pembayaran ini tidak tersedia untuk server ini", {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      let detailTrans = [];
      // const pesanan = decrypt(JSON.parse(localStorage.getItem("pesanan")))
      const branch = JSON.parse(localStorage.getItem("dataBranch"));
      const coa = await api.apiPrepare.coaBranchAll({
        userId: detailUsers.nama == "" ? "Admin" : detailUsers.nama,
      });
      const s = onHitung(order);
      let date = {
        date: formatDate(new Date()),
        time: formatMinutes(new Date()),
      };
      for (const items of state.dataOrder) {
        detailTrans.push(
          detailTrens(items, detailUsers, branch, coa.data[0], date)
        );
      }
      localStorage.setItem(
        "chargesNote",
        JSON.stringify(encrypt(s.chargeNotes))
      );
      setLoading(true);
      let dataDetailData = decrypt(
        JSON.parse(localStorage.getItem("detailData"))
      );
      if (dataDetailData) {
        dataDetailData = dataDetailData;
      } else {
        dataDetailData = {};
      }
      dataDetailData["branch_id"] = branch.branchID;
      dataDetailData["grand_total_nett"] = s.data.grand_total_net;
      dataDetailData["total"] = s.data.sub_total;
      dataDetailData["sub_total"] = s.data.sub_total;
      dataDetailData["grand_total"] = s.data.grand_total;
      dataDetailData["kembali"] = 0;
      dataDetailData["payment_cash_coa"] = coa.data["0"]["coa_cash"];
      dataDetailData["payment_cash_coa_name"] = coa.data["0"]["coa_cash_name"];
      dataDetailData["payment_cash_value"] = 0;
      dataDetailData["payment_type"] = 3;
      const paymentOthersLabel = item?.id === "NFC" ? "Nobu" : item?.id;
      dataDetailData["payment_others_name"] = paymentOthersLabel;
      dataDetailData["payment_others_value"] = s.data.grand_total_net;
      dataDetailData["payment_others_edc"] = paymentOthersLabel;
      dataDetailData["payment_others_coa"] = xendit?.coa?.coa;
      dataDetailData["charges_value"] = s.data.charges_value;
      if (item?.id === "Nobu" || item?.id === "NFC") {
        dataDetailData["payment_others_coa_name"] = paymentOthersLabel;
        dataDetailData["total_bayar"] = s.data.grand_total_net;
        dataDetailData["_onUpdate"] = s.data.grand_total_net;
      }

      dataDetailData["chargesNote"] = JSON.stringify(s.chargeNotes);
      dataDetailData["payment_others_note"] = paymentOthersLabel;
      const diskon = [];
      const enkrip = JSON.stringify({
        userId: "-",
        transMode: "edit",
        detailData: dataDetailData,
        detailTrans: JSON.stringify(detailTrans),
        discountsNote: JSON.stringify(diskon),
        chargesNote: JSON.stringify(state?.data[0]?.chagerNote),
        from_origin: "*",
        userServer: userServer,
        transCode: "si",
        transId: branch.detailData,
        // branch_id: JSON.parse(localStorage.getItem('dataBranch')).branchID
      });
      const dataenkrip = await FETCH_API("encryption/encrypt", {
        string: enkrip,
      });
      setDetailTrans3(detailTrans);
      localStorage.setItem("detailTrans", JSON.stringify(encrypt(detailTrans)));
      localStorage.setItem(
        "detailData",
        JSON.stringify(encrypt(dataDetailData))
      );
      if (item["id"] == "Nobu") {
        console.log("ini item id dari onPembayaran", item["id"]);
        const resultSave = await onSave("proses");
        if (resultSave.status == "OK") {
          onCallSocketIO();
          setLoading(false);
          await getQRNobu(item, dataDetailData, detailTrans);
          return;
        } else {
          setLoading(false);
          addToast(resultSave.message, {
            appearance: "error",
            autoDismiss: true,
          });
          return;
        }
      }

      if (item["id"] == "NFC") {

        const resultSave = await onSave("proses");
        if (resultSave.status == "OK") {
          onCallSocketIO();
          setLoading(false);
          await activateNFC(item, dataDetailData, detailTrans);
          return;
        } else {
          setLoading(false);
          addToast(resultSave.message, {
            appearance: "error",
            autoDismiss: true,
          });
          return;
        }

      }
      // else if (item["id"] == "Xendit") {
      //   const result = await onSave("proses");
      //   if (result.status == "OK") {
      //     const dataQR = await api.apiXendit.getQRCodeXendit({
      //       transId: branch.detailData,
      //       amount: parseInt(s.data.grand_total_net),
      //       branch_id: JSON.parse(localStorage.getItem("dataBranch")).branchID,
      //       success_redirect_url: `${baseUrl}#/payment-succes`,
      //       // success_redirect_url:
      //       //   "https://localhost:3000/tableqr#/payment-succes",
      //       source: "Uruz-QR-Food-Order",
      //       data: "",
      //       userServer: userServer,
      //     });
      //     setLoading(false);
      //     if (dataQR && dataQR.invoice_url) {
      //       onCallSocketIO();
      //       window.location.href = dataQR.invoice_url;
      //       // navigate(`${router}/payment-succes`);
      //     } else {
      //       addToast("Silahkan Pilih Metode Pembayaran lain", {
      //         appearance: "error",
      //         autoDismiss: true,
      //       });
      //     }
      //   } else {
      //     setLoading(false);
      //     addToast(result.message, {
      //       appearance: "error",
      //       autoDismiss: true,
      //     });
      //   }
      // } 
      else {
        const result = await onSave("proses");
        if (result.status == "OK") {
          setLoading(false);
          // navigate(`${router}/payment-succes`);
        } else {
          setLoading(false);
          addToast(result.message, {
            appearance: "error",
            autoDismiss: true,
          });
        }
      }
    } catch (error) {
      setLoading(false);
      showLog(`Metode Pembayaran ${error}`);
    }
  }

  function getMonthName(month) {
    showLog("MetodePembayaran Masuk getMonthName");
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    return months[month - 1];
  }

  async function onSendEmail() {
    showLog("MetodePembayaran Masuk onSendEmail");
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    let orderDate = JSON.parse(localStorage.getItem("orderDate"));
    if (!orderDate) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      orderDate = {
        nama: "",
        email: "",
        nomerHp: "+62",
        date: `${year}-${month}-${day}`,
        time: `${hours}:${minutes}`,
      };
    }
    const [year, month, day] = orderDate.date.split("-");
    const [hours, minutes] = orderDate.time.split(":");
    const formattedTime = `${hours}:${minutes.padStart(2, "0")}`;
    const formattedDate = `${day} ${getMonthName(
      parseInt(month)
    )} ${year} ${formattedTime}`;
    const sii = order.map((x) => ({
      namaProduct: x.name
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" "),
      qty: x["qty"],
      price: x["price"],
      subtotal: x["price"] * x["qty"],
    }));
    const s = onHitung(order);
    let data = {};
    data.tanggal = order[0]["trans_date"];
    let nomorMeja = localStorage.getItem("meja");
    let cashierName =
      decrypt(JSON.parse(localStorage.getItem("cashierName"))) || "";
    let payloadEmail = {
      branch_name: dataBranch.branchName,
      carabayar: localStorage.getItem("typePayment") || "",
      cashier_name: cashierName
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" "),
      customer_id:
        decrypt(JSON.parse(localStorage.getItem("dataDiriId"))) || "",
      detailData: sii,
      email: localStorage.getItem("dataDiriEmail") || "",
      grandTotal: s.data.grand_total + s.data.charges_value_non_pb1,
      idTransaksi: dataBranch.detailData,
      linkLihatDetail: `${baseUrl}tableqr/lacak-pesanan`,
      namaPembeli: localStorage.getItem("dataDiriName") || "",
      subTotal: s.data.sub_total,
      subjectnya: `Invoice Pesanan - Meja ${nomorMeja}`,
      tglTransaksi: formattedDate,
      url: imageBaseUrl + dataBranch.picpath,
    };
    sessionStorage.setItem(
      "tableQrPayloadEmail",
      JSON.stringify(encrypt(payloadEmail))
    );
  }

  async function onCallSocketIO() {
    showLog("MetodePembayaran Masuk onCallSocketIO");
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    const detailDataMapping = {
      "1st_process_attempt": null,
      approved_by: "",
      approved_date: "",
      billed_by: null,
      billed_date: null,
      branch_address: "",
      branch_id: "",
      branch_name: "",
      branch_npwp: "-",
      branch_picpath: "",
      branch_tel1: "",
      cashlez_callbacked: null,
      cashlez_link: "",
      cashlez_qr: "",
      charges_note: [],
      charges_value: 0,
      charges_value_non_pb1: 0,
      charges_value_pb1: 0,
      charges_value_total: 0,
      checked_by: null,
      checked_date: null,
      checked_note: null,
      client_order_id: null,
      coa_ar_customer: "",
      coa_ar_customer_name: "",
      coa_dp_so: "",
      coa_dp_so_name: "",
      coa_dp_so_tax: "",
      coa_dp_so_tax_name: "",
      code: "",
      created_by: "",
      created_by_name: "",
      created_date: "",
      customer_address: "",
      customer_id: "",
      customer_name: "",
      customer_npwp: "",
      delivery_receiver_address: "",
      delivery_receiver_id: "",
      delivery_receiver_nama: null,
      delivery_receiver_name: null,
      delivery_receiver_phone: "",
      discounts_note: [],
      discounts_value: 0,
      discounts_value_total: 0,
      dp_so: 0,
      edit_lock_by: "",
      edit_lock_by_name: "",
      estimated_pickup_time: null,
      from: "",
      grand_total: 0,
      grand_total_nett: 0,
      harga_a_note: 0,
      harga_a_note_show: "",
      hide: 0,
      id: "",
      is_billed: 0,
      is_checked: 0,
      is_prepared: 0,
      is_prepared_show: "",
      jumlah_tamu: 0,
      kembali: 0,
      kurir_id: "-",
      kurir_layanan: null,
      kurir_service: null,
      marketing_id: "",
      marketing_name: "",
      no_faktur_pajak: "",
      note: "",
      oc_id: null,
      packaging: 0,
      payment_cash_coa: "",
      payment_cash_coa_name: "",
      payment_cash_value: 0,
      payment_cc1_coa: "",
      payment_cc1_coa_name: "",
      payment_cc1_edc: "",
      payment_cc1_note: "",
      payment_cc1_value: 0,
      payment_cc2_coa: "",
      payment_cc2_coa_name: "",
      payment_cc2_edc: "",
      payment_cc2_note: "",
      payment_cc2_value: 0,
      payment_dc1_coa: "",
      payment_dc1_coa_name: "",
      payment_dc1_edc: "",
      payment_dc1_note: "",
      payment_dc1_value: 0,
      payment_dc2_coa: "",
      payment_dc2_coa_name: "",
      payment_dc2_edc: "",
      payment_dc2_note: "",
      payment_dc2_value: 0,
      payment_others_coa: "",
      payment_others_coa_name: "",
      payment_others_edc: "",
      payment_others_note: null,
      payment_others_value: 0,
      payment_total: 0,
      payment_type: 0,
      payment_type_show: "",
      picpath: "",
      platform_order_id: null,
      po_customer: "",
      posted_acc_date: null,
      posted_acc_note: null,
      posted_acc_status: 0,
      posted_inv_date: null,
      posted_inv_note: null,
      posted_inv_status: 0,
      prepared_by: null,
      prepared_by_name: "",
      prepared_date: null,
      prepared_note: null,
      print_x_times: 0,
      print_x_times_A6: 0,
      processed_by: "",
      processed_by_name: "",
      processed_date: null,
      project_id: null,
      rc_id: "",
      reservation_detail_id: null,
      room_id: null,
      so_code: "",
      so_date: "",
      so_id: "",
      sr_id: "",
      sub_total: 0,
      sync_by: null,
      sync_date: null,
      sync_trans_status: 0,
      table_id: "",
      table_reservation_id: null,
      tgl_customer_terima: null,
      tgl_keluar: null,
      therapist_id: null,
      top: 0,
      total: 0,
      total_coin_earned: 0,
      total_point_earned: 0,
      trans_date: "",
      trans_from: "",
      trans_status: 0,
      trans_status_oc: null,
      trans_status_show: "",
      updated_by: "",
      updated_by_name: "",
      updated_date: "",
      void_by: "",
      void_by_name: "",
      void_date: null,
      void_note: null,
    };
    const orderSelectedMapping = {
      accepted_rejected_at: null,
      accepted_rejected_at_show: null,
      brand_id: "",
      coa_inv: "",
      coa_sales: "",
      curr: "",
      detail_disc1: 0,
      detail_disc2: 0,
      detail_disc_value: 0,
      detail_note: "",
      expired: "",
      header: null,
      height_packing: 0,
      // id: dataBranch.detailData,
      id: "",
      indent: 0,
      kitchen_type_id: "",
      length_packing: 0,
      ln: "-",
      name: "",
      num: 0,
      num_paket: null,
      ordered_at: "",
      ordered_at_show: "",
      ordered_by: "",
      picpath1_thumb: "",
      prepared_at: "",
      prepared_at_show: "",
      prepared_by: "",
      price: 0,
      product_id: "",
      product_name: "",
      promo_name: "",
      promo_paket: 0,
      promo_price: 0,
      promo_qty: 0,
      qty: 0,
      qty_order: 0,
      qty_unit: 0,
      rate: 0,
      sn: "",
      status_save: "",
      trans_id: dataBranch.detailData,
      table_id: localStorage.getItem("meja"),
      tipe_promo: null,
      total: 0,
      unit_id: "",
      unit_id_small: "",
      use_expired: 0,
      use_ln: 0,
      use_sn: 0,
      void_at: null,
      void_at_show: null,
      void_by: null,
      void_note: null,
      void_type: 0,
      warehouse_id: "",
      warehouse_name: "",
      weight_packing: 0,
      width_packing: 0,
    };
    const dataDetailData = decrypt(
      JSON.parse(localStorage.getItem("detailData"))
    );
    const datadetailTrans = decrypt(
      JSON.parse(localStorage.getItem("detailTrans"))
    );
    const mappedDetailData = mapData(dataDetailData, detailDataMapping);
    const orderSelectedArray = datadetailTrans.map((item) => ({
      ...orderSelectedMapping,
      ...item,
      product_name: item.name || "",
    }));
    mappedDetailData.charges_note = state.data[0].chagerNote;
    mappedDetailData.branch_address = dataBranch.branchAddress;
    mappedDetailData.branch_name = dataBranch.branchName;
    mappedDetailData.branch_tel1 = dataBranch.branchTel;
    mappedDetailData.picpath = dataBranch.picpath;
    mappedDetailData.picpath1_thumb = dataBranch.picpath_thumb;
    mappedDetailData.branch_npwp = dataBranch.npwpp;
    mappedDetailData.trans_date = order[0]["trans_date"];
    mappedDetailData.delivery_receiver_name =
      localStorage.getItem("dataDiriName") || "";
    mappedDetailData.note =
      decrypt(JSON.parse(localStorage.getItem("customerNote"))) || "";
    const tableQrSocketData = {
      source: "FROM WEBSITE",
      table_id: localStorage.getItem("meja"),
      branch_id: dataBranch.branchID,
      trans_id: dataBranch.detailData,
      userServer: userServer,
      trans_date: order[0]["trans_date"],
      detailData: mappedDetailData,
      orderSelected: orderSelectedArray,
      mode: ["kitchen", "transaction"],
      posData: {
        detailData: mappedDetailData,
        link: "",
        linkGet: "",
        orderSelected: orderSelectedArray,
        posForm: "",
        posMode: "",
        transMode: "",
      },
      jumlah_tamu: "",
      is_billed: "",
      billed_date: "",
      status: "",
      posMode: "",
      stat: 0,
    };
    sessionStorage.setItem(
      "tableQrSocketData",
      JSON.stringify(encrypt(tableQrSocketData))
    );
    if (socket?.connected) {
      showLog(`Socket Connected With ID = ${socket.id}`);
    } else {
      socket.once("connect", () =>
        showLog(`Socket Connected With ID = ${socket.id}`)
      );
    }
    let savedSiSocketData = {
      source: "FROM WEBSITE",
      billed_date: "",
      is_billed: "",
      jumlah_tamu: "",
      posMode: "",
      branch_id: dataBranch.branchID,
      table_id: localStorage.getItem("meja"),
      trans_date: order[0]["trans_date"],
      trans_id: dataBranch.detailData,
      userServer: userServer,
    };
    sessionStorage.setItem(
      "savedSiSocketData",
      JSON.stringify(encrypt(savedSiSocketData))
    );
  }

  async function loginUruzPro() {
    try {
      const login = await fetch('https://uruzpro.com/auth-services/token/', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Accept-Encoding': 'gzip;q=1.0, compress;q=0.5',
        },
        body: JSON.stringify({
          email: 'syahrul05011@gmail.com',
          password: '12345aA-',
        }),
      });

      const resultLogin = await login.json();

      if (resultLogin && resultLogin.token) {
        console.log('hasil response login uruzpro', resultLogin);
        localStorage.setItem("tokenUruzPro", resultLogin.token);
        return resultLogin;
      } else {
        console.log('gagal login uruzpro', resultLogin);
        return;
      }
    } catch (error) {
      console.log('Terjadi error:', error);
    }
  }


  function mapData(source, target) {
    showLog("MetodePembayaran Masuk mapData");
    const result = { ...target };
    for (const key in result) {
      if (source.hasOwnProperty(key)) {
        result[key] = source[key];
      } else {
        if (typeof result[key] === "string") result[key] = "";
        else if (Array.isArray(result[key])) result[key] = [];
        else if (result[key] === null) {
        } // no change needed
        else if (typeof result[key] === "number") result[key] = 0;
      }
    }
    return result;
  }

  return (
    <div>
      <Navbar
        urlBack={"/lacak-pesanan"}
        type="back"
        label="Pilih Metode Pembayaran"
      />
      <div style={{ paddingTop: "20%" }}>
        {
          <div>
            <div
              style={{
                margin: "10px 20px 0px 20px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
              }}
            >
              {/* Cashier Option */}
              <div
                onClick={async () => {
                  localStorage.setItem("typePayment", "Cash");
                  onCallSocketIO();
                  onSendEmail();
                  navigate(router + "/bill-cash");
                  // const result = await onSave("proses");
                  // if (result.status == "OK") {
                  //   setLoading(false);
                  //   navigate(`${router}/payment-succes`);
                  // } else {
                  //   setLoading(false);
                  //   addToast(result.message, {
                  //     appearance: "error",
                  //     autoDismiss: true,
                  //   });
                  // }
                }}
                style={{
                  width: "49%",
                  backgroundColor: "#fff",
                  height: 400,
                  margin: "10px 0px",
                  borderRadius: 5,
                  boxShadow: "0px 1px 5px -3px #000",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <img
                  width="110px"
                  height="110px"
                  src={Cashier}
                  style={{ marginBottom: 8 }}
                />
                <div
                  className="fonts700"
                  style={{ fontSize: 18, textAlign: "center", marginTop: "1%" }}
                >
                  Bayar Ke Kasir
                </div>
              </div>
              {pay.map((items, index) => {
                // if (isPillowcake && (items?.id === "Nobu" || items?.id === "NFC")) {
                //   return null;
                // }

                if (items.id === "Nobu") {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        localStorage.setItem("typePayment", items.id);
                        // onSendEmail();
                        onPembayaran(items);
                      }}
                      style={{
                        width: "49%",
                        backgroundColor: "#fff",
                        height: 400,
                        margin: "10px 0px",
                        borderRadius: 5,
                        boxShadow: "0px 1px 5px -3px #000",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        width="110px"
                        height="110px"
                        src={items.image}
                        style={{ marginBottom: 8 }}
                      />
                      <div
                        className="fonts700"
                        style={{
                          fontSize: 18,
                          textAlign: "center",
                          marginTop: "1%",
                        }}
                      >
                        Scan QR
                      </div>
                    </div>
                  );
                }

                if (items.id === "NFC") {
                  return (
                    <div
                      key={index}
                      onClick={() => {
                        localStorage.setItem("typePayment", items.id);
                        // onSendEmail();
                        onPembayaran(items);
                      }}
                      style={{
                        width: "49%",
                        backgroundColor: "#fff",
                        height: 400,
                        margin: "10px 0px",
                        borderRadius: 5,
                        boxShadow: "0px 1px 5px -3px #000",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <img
                        width="110px"
                        height="110px"
                        src={items.image}
                        style={{ marginBottom: 8 }}
                      />
                      <div
                        className="fonts700"
                        style={{
                          fontSize: 18,
                          textAlign: "center",
                          marginTop: "1%",
                        }}
                      >
                        Tap (QRIS NFC)
                      </div>
                    </div>
                  );
                }
              })}
              {/* <div
                onClick={() => {
                  onSendEmail();
                }}
                style={{
                  width: "49%",
                  backgroundColor: "#fff",
                  height: 400,
                  margin: "10px 0px",
                  borderRadius: 5,
                  boxShadow: "0px 1px 5px -3px #000",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <img
                  width="110px"
                  height="110px"
                  // src={items.image}
                  style={{ marginBottom: 8 }}
                />
                <div
                  className="fonts700"
                  style={{
                    fontSize: 18,
                    textAlign: "center",
                    marginTop: "1%",
                  }}
                >
                  Qris Tap NFC
                </div>
              </div> */}
            </div>
          </div>
        }
        {loading && <LoadingFull />}
      </div>
    </div>
  );
}
